import React from 'react'

import asoleacion from "./../../../UI/general/asoleacion.svg"

interface Props {
  colorsData: any,
  handleOpenAsoleacionModal: any,
  topbarHidden: boolean
}

interface State {}

class AsoleacionBtnMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {

    }
  }

  render(): React.ReactNode {
      return(
        <div
          className='asoleacion-btn-mobile'
          onClick = {() => {this.props.handleOpenAsoleacionModal()}}
          style={{
            top: this.props.topbarHidden ? "1.5rem":"4.25rem",
            transition: "all 0.3s ease-in-out"
          }}
        >
          <img src={asoleacion} alt="" className="asolacion-btn-image"/>
        </div>
      )
  }
}

export default AsoleacionBtnMobile